<template>
  <div>
    <div class="login-box bgf5">
      <div class="login">
        <el-tabs v-model="activeName">
          <el-tab-pane label="密码登录" name="password">
            <el-form :model="password" :rules="passRules" ref="password">
              <el-form-item prop="mobile">
                <el-input v-model="password.mobile" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="password.passWord" placeholder="密码" show-password></el-input>
              </el-form-item>
              <div class="el-row--flex">
                <el-checkbox v-model="password.checked">记住密码</el-checkbox>
              </div>
              <el-button class="flup" type="primary" @click="submit('password')">登录</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="短信登录" name="message">
            <el-form :model="message" :rules="messRules" ref="message">
              <el-form-item prop="mobile">
                <el-input type="text" v-model="message.mobile" placeholder="手机号" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="message.code" placeholder="图形验证码" maxlength="4"></el-input>
                <img-code></img-code>
                &nbsp;不区分大小写
              </el-form-item>
              <el-form-item prop="validate">
                <el-input v-model="message.validate" placeholder="短信验证码" maxlength="6"></el-input>
                <el-button type="primary" @click="send" :disabled="resetTime != 60">{{resetTime == 60 ? '获取验证码' : '获取（' + resetTime + '）'}}</el-button>
              </el-form-item>
              <el-button class="flup" type="primary" @click="submit('message')">登录</el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div class="tip">还没有账号？<span style="cursor: pointer;" @click="$router.push('/register')">立即注册</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImgCode from '@/components/img-code.vue'

  export default {
    components: {
      ImgCode
    },
    data() {
      return {
        activeName: 'password',
        resetTime: 60,
        password: {
          mobile: '',
          passWord: '',
          checked: false
        },
        passRules: {
          mobile: [
            { required: true,message: '手机号不能为空',trigger: 'blur' },
            { min: 11,message: '手机号输入不正确',trigger: 'change' }
          ],
          passWord: [
            { required: true,message: '密码不能为空',trigger: 'blur' },
            { min: 6,max: 20,message: '密码长度在6-20位',trigger: 'change' }
          ]
        },
        message: {
          mobile: '',
          code: '',
          validate: ''
        },
        messRules: {
          mobile: [
            { required: true,message: '手机号不能为空',trigger: 'blur' },
            { min: 11,message: '手机号输入不正确',trigger: 'change' }
          ],
          validate: [
            { required: true,message: '短信验证码不能为空',trigger: 'blur' },
            { min: 6,message: '短信验证码长度不对',trigger: 'change' }
          ]
        }
      }
    },
    mounted() {
      if (localStorage.getItem('password')) {
        this.password.mobile = localStorage.getItem('mobile');
        this.password.passWord = localStorage.getItem('password');
        this.password.checked = true;
      }
	  
      if (document.cookie && document.cookie != '') {
        this.$message.warning('您已登录，正在跳转...');
        this.$store.commit('loginChange', true);
        this.$router.push('/');
      } else {
        this.$message.error('用户信息已过期，请重新登录');
        this.$store.commit('loginChange', false);
      }
    },
    methods: {
      reset() {
        const that = this;
        setTimeout(() => {
          that.$refs['password'].resetFields();
          that.$refs['message'].resetFields();
        }, 300)
      },
      refreshTime() {
        const that = this;
        const resetInterval = setInterval(function(){
          if (that.resetTime == 0) {
            that.resetTime = 60;
            clearInterval(resetInterval);
          } else {
            that.resetTime--;
          }
        }, 1000)
      },
      send() {
        if (this.message.code == '') {
          this.$message.error('请先验证图形验证码');
        } else if (this.message.code.length != 4) {
          this.$message.error('图形验证码格式不正确');
        } else if (this.message.mobile == '') {
          this.$message.error('验证码要发给谁呢？');
        } else if (this.message.mobile.length != 11) {
          this.$message.error('手机号格式不正确');
        } else {
          this.resetTime = 59;
          this.$global.axios.post(this, '/sywl/user/message', {
            mobile: this.message.mobile,
            imgCode: this.message.code
          }, res => {
            this.$message.success('验证码发送成功');
            this.refreshTime();
          }, res => {
            this.resetTime = 60;
          })
        }
      },
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$global.axios.post(this, formName == 'password' ? '/sywl/user/pasLogin' : '/sywl/user/codeLogin', formName == 'password' ? this.password : this.message, res => {
              if (formName == 'password') {
                if (this.password.checked) {
                  localStorage.setItem('mobile', this.password.mobile);
                  localStorage.setItem('password', this.password.passWord);
                }
              }
              this.$message.success('登录成功');
              this.$store.commit('loginChange', true);
              this.$router.push('/');
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    watch: {
      activeName(n) {
        this.reset();
      }
    }
  }
</script>

<style lang="scss">
  .login-box {
    padding: 82px 0;

    .login {
      position: relative;
      width: 680px;
      height: 702px;
      margin: 0 auto;
      padding: 73px 116px 86px 111px;
      background-color: #fff;
      border-radius: 4px;
      box-sizing: border-box;

      .el-tabs__nav {
        padding: 18px 0;
      }

      .el-tabs__item {
        font-size: 22px;
        color: #999;

        &.is-active {
          font-size: 28px;
          color: #333;
        }
      }

      .el-form-item {
        margin-bottom: 0;

        &__content {
          margin-top: 26px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          white-space: nowrap;

          .el-button {
            margin-top: 0;
            margin-left: 10px;
          }
        }
      }

      .el-checkbox {
        margin-top: 26px;
      }

      .el-button {
        margin-top: 26px;

        &.flup {
          width: 100%;
          cursor: pointer;
        }
      }

      .tip {
        margin-top: 20px;
        font-size: 14px;
        color: #666;

        span {
          color: #1875f0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue